import gql from 'graphql-tag';

export default fields => gql`
mutation ($input: UpdateProviderInput!) {
    updateProvider (input: $input) {
        __typename
        ${[...['id', 'name'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/Providers/UpdateMutation.js